<template>
  <div class="form-field-wrap">
    <vue-editor
      v-if="!readonly"
      v-model="text"
      :ref="name"
      useCustomImageHandler
      @imageAdded="handleImageAdded"
      :editorToolbar="customToolbar"
    >
      <!-- :editorOptions="editorSettings" -->
      <!-- :customModules="customModulesForEditor" -->
    </vue-editor>
    <div
      v-else
      v-html="value"
    ></div>

    <form-error
      :error="error"
      :name="name"
    >
    </form-error>
    <help-text :label="helpText"></help-text>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
// import { ImageDrop } from 'quill-image-drop-module'
// import ImageResize from 'quill-image-resize-module'

export default {
  props: {
    value: { type: String, required: true },
    error: { type: Object, required: true },
    name: { type: String, required: true },
    url: { type: String, required: true },
    uuid: { type: String, required: true },
    readonly: { type: Boolean, default: false },
    helpText: { type: String, default: '' }
  },
  data () {
    return {
      text: this.value,
      // customModulesForEditor: [
      //   { alias: 'imageDrop', module: ImageDrop },
      //   { alias: 'imageResize', module: ImageResize }
      // ],
      // editorSettings: {
      //   modules: {
      //     imageDrop: true,
      //     imageResize: {}
      //   }
      // },
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'direction': 'rtl' }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'font': [] }],
        [{ 'align': [] }],
        ['link', 'image', 'video'],
        ['clean']
      ]
    }
  },
  watch: {
    error () {
      const focused = this.error && this.name && this.error.fieldId === this.name
      if (focused) {
        this.$nextTick(() => { this.$refs[this.name].quill.focus() })
      }
    },
    text () {
      this.$emit('input', this.text)
    },
    value () {
      this.text = this.value
    }
  },
  mounted () {
    // console.log('this.text', this.text)
    this.text = this.value
  },
  methods: {
    input ($event) {
      this.$emit('input', $event.target.value)
    },
    async handleImageAdded (file, Editor, cursorLocation, resetUploader) {
      try {
        var formData = new FormData()
        formData.append('file', file)
        const url = `${this.url}${this.uuid}`
        const { data } = await this.$http.post(url, formData)

        const fileUrl = `${url}/${data.fileName}` // Get url from response
        Editor.insertEmbed(cursorLocation, 'image', fileUrl)
        resetUploader()
      } catch (ex) {
        console.error(ex, ex.response)
      }
    }
  },

  components: {
    FormError: () => import('@/component/ui2/form/FormError'),
    HelpText: () => import('@/component/ui2/common/HelpText'),
    VueEditor
  }
}
</script>
